import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import MobileActions from "./components/MobileActions";
import QuoteModal from "./components/QuoteModal";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

function RouteReset() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return null;
}

function AppContent() {
  const [language, setLanguage] = useState("ar");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteProductId, setQuoteProductId] = useState("");

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.title = language === "ar"
      ? "مطبعة طريق القمر للطباعة والتغليف | جدة"
      : "Moonline Printing and Packaging | Jeddah";
  }, [language]);

  const toggleLanguage = () => setLanguage((current) => current === "ar" ? "en" : "ar");
  const openQuote = (productId = "") => {
    setQuoteProductId(productId);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setQuoteProductId("");
  };

  return (
    <div className={`App app-${language}`}>
      <RouteReset />
      <SiteHeader language={language} onLanguageToggle={toggleLanguage} onQuote={openQuote} />
      <Routes>
        <Route path="/" element={<Home language={language} onQuote={openQuote} />} />
        <Route path="/products" element={<Products language={language} onQuote={openQuote} />} />
        <Route path="/services" element={<Services language={language} onQuote={openQuote} />} />
        <Route path="/contact" element={<Contact language={language} onQuote={openQuote} />} />
      </Routes>
      <SiteFooter language={language} />
      <MobileActions language={language} onQuote={openQuote} />
      <QuoteModal open={quoteOpen} language={language} onClose={closeQuote} selectedProductId={quoteProductId} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
